
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videomeeting",
      function () {
        return require("private-next-pages/videomeeting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/videomeeting"])
      });
    }
  